import { LOGIN_ERROR } from '../mutation-types';

const state = {

    status: false

};

interface TLoginError {

    status: boolean;

}

const mutations = {

    [ LOGIN_ERROR ]( state: TLoginError, status: boolean ): void {

        state.status = status;

    }

};

export default {

    state,
    mutations

};
